<script>


import moment from "moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {

  },
  props: {
    pedidoList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },

  data() {
    return {
      loadingPedidoDetail: false,
      valorTotalItens: 0,
      titleModalItensPed: 'Resumo da Transferência',
      showModalItensPed: false,
      fornecData: {},
      movTransfData: {},
      movTransfItensData: {},
    };
  },

  mounted() {
    console.log('mounted transferencias-table')
    console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'FA':
          result = 'Faturado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/movtransf/editar/${idData}`)
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.loadingPedidoDetail = true
      this.showModalItensPed = true
      this.valorTotalItens = 0

      api.get(`${getBaseUrl()}api/movtransf`, {
        params: { iddata: idData }
      }).then((res) => {
        console.log('then axios_detalhe')
        this.movTransfData = res.data[0]
        this.fornecData = res.data[1]
        this.movTransfItensData = res.data[5]

        // console.log(res.data)

        if (this.movTransfItensData.length > 0){
          this.movTransfItensData.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            this.valorTotalItens += valor
          });
        }

        console.log('this.movTransfItensData')
        console.log(this.movTransfItensData)


        this.titleModalItensPed = `Resumo da Transferência (${ this.movTransfData.id })`
        this.loadingPedidoDetail = false
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="align-middle">Código</th>
        <th class="align-middle">Origem</th>
        <th class="align-middle">Cidade</th>
        <th class="align-middle">Estado</th>
        <th class="align-middle">Data</th>
        <th class="align-middle text-end">Valor</th>
        <th class="align-middle">Status</th>

        <th class="text-end">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in pedidoList" :key="data.id">


        <td>
          <a href="javascript: void(0);" @click="editar(data.id)" class="text-body fw-bold">{{
              data.id
            }}</a>
        </td>

        <td>{{ data.nome }}</td>
        <td>{{ data.cidade }}</td>
        <td>{{ data.estado }}</td>
        <td>{{ formatDateTime(data.created_at) }}</td>
        <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'FA' ? 'badge-soft-success' :
                    data.status === 'EL' ? 'badge-soft-warning' : data.status === 'CO' ? 'badge-soft-info' : 'badge-soft-danger'"
              >{{ nomeStatus(data.status) }}</span
              >
        </td>
        <td>

          <div class="button-items text-end">

            <b-button variant="outline-success" @click="detalhes(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

          </div>

        </td>

      </tr>
      </tbody>
    </table>




    <b-modal :title="titleModalItensPed" v-model="showModalItensPed" centered hide-footer >

      <div class="row" v-if="loadingPedidoDetail">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingPedidoDetail && movTransfData && fornecData">


        <p class="mb-2">
          Código:
          <span class="text-primary">{{ movTransfData.id }}</span>
        </p>
        <p class="mb-4">
          <router-link :to="`/cliente/detalhe/${fornecData.id}`" target="_blank">
            Fornecedor:
            <span class="text-primary">{{ movTransfData.fornec }} - {{ fornecData.nome }}</span>
          </router-link>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Descrição</th>
              <th scope="col" class="text-end">Valor</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="data in movTransfItensData" :key="data.id">
              <th scope="row">
                <h5 class="text-muted mb-0">{{ data.produto.substr(7, 15) }} </h5>
                <div>
                  <img v-if="data.img1"
                       :src="data.img1"
                       alt
                       class="avatar-sm"/>
                  <span
                      v-else
                      class="avatar-title rounded-circle" style="min-height: 50px;">{{ data.produto.substring(0, 3) }}</span>
                </div>

              </th>
              <td>
                <div>

                  <h5 class="text-truncate font-size-14 mb-0">
                    {{ data.descprod.substring(0, 28) }}
                  </h5>
                  <p class="text-muted mb-0">R$ {{ formatDecimal(data.vlrunitliq) }} x {{ formatInteger(data.qtd) }}</p>
                </div>
              </td>
              <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Sub Total:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Frete:</h6>
              </td>
              <td class="text-end">Grátis</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Total:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(valorTotalItens) }}</td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

  </div>
  <!-- end table -->
</template>
